export default "__VITE_ASSET__H8HuTgD8__"